import React, { useEffect, useState } from 'react';
import '../styles/Product.css';
import { getJson } from '../api';
import { useCart } from '../context/CartContext';

const normalizeProduct = (data) => {
  if (!data || typeof data !== 'object') {
    return null;
  }
  const priceNumber = Number(data.price);
  return {
    ...data,
    price: Number.isFinite(priceNumber) ? priceNumber : null,
  };
};

function Product() {
  const [product, setProduct] = useState(null);
  const [status, setStatus] = useState({ type: '', message: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const { addItem } = useCart();

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const data = await getJson('/products/featured');
        if (isMounted) {
          setProduct(normalizeProduct(data));
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  const handleAddToCart = () => {
    if (!product) {
      return;
    }
    if (typeof product.price !== 'number') {
      setStatus({ type: 'error', message: 'Product pricing is unavailable right now.' });
      return;
    }
    addItem(product);
    setStatus({ type: 'success', message: `${product.name} added to cart.` });
  };

  if (loading) {
    return (
      <div className="container product-page">
        <p>Loading product...</p>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="container product-page">
        <p className="status-message error">
          {error || 'Unable to load product. Please try again later.'}
        </p>
      </div>
    );
  }

  return (
    <div className="container product-page">
      <h2>{product.name}</h2>
      <img className="product-img" src={product.image} alt={product.name} />
      <div className="product-details">
        <p>{product.description}</p>
        {typeof product.price === 'number' ? (
          <strong className="product-price">${product.price.toFixed(2)}</strong>
        ) : (
          <strong className="product-price unavailable">Price unavailable</strong>
        )}
      </div>
      <button className="add-to-cart" onClick={handleAddToCart}>
        Add to Cart
      </button>
      {status.message && (
        <div
          role="status"
          aria-live="polite"
          className={`status-message ${status.type}`}
        >
          {status.message}
        </div>
      )}
    </div>
  );
}

export default Product;
